import React from "react";
import { UserAvatar } from "components/Atoms/Avatar";
import moment from "moment";
import { formatWrittenDateTimeUtc } from "utilities";
import LinkedShowLines from "components/LinkedShows/LinkedShowElement";
import { ShowSidePanel } from "components/SidePanel/Show/ShowSidePanel";
import { AppointmentPhase } from "components";
import { PhosphorWarning } from "components/Atoms/PhosphorIcon";

interface Props {
  lastModifiedShow: server.dto.ShowLastModified
}

class LastModifiedShowRowCard extends React.Component<Props> {
  public render(): JSX.Element {
    const item = this.props.lastModifiedShow;
    const user = item.lastModifiedBy;

    const lastModifiedMoment = moment.utc(item.lastModifiedUtc);

    return (
      <div className="radius hoverable">
        <ShowSidePanel
          canEdit
          showId={item.showId}
          trigger={<>
            <div>
              <div>
                <AppointmentPhase value={item.status.appointmentPhase} displayLabel={false} />
              </div>
              {!item.validated && <div className="margin-top-small">
                <PhosphorWarning iconSize="large" />
              </div>}
            </div>
            <div className="flex-column gap-small grow1">

              <LinkedShowLines
                dateTime={item.dateTime}
                eventDescription={item.eventDescription}
                venueDescription={item.venueDescription}
                format="big" />

              <div title={formatWrittenDateTimeUtc(lastModifiedMoment)} className="s1_smaller">{lastModifiedMoment.fromNow()} {RESX.RecordInformation.by} {user.fullName}</div>
            </div>

            <div>
              <UserAvatar user={user} />
            </div>
          </>}
        />
      </div>
    );
  }
}

export default LastModifiedShowRowCard;
